var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fieldset',{staticClass:"zpa-form-group"},[(_vm.title)?_c('legend',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('zpa-row',{attrs:{"wrap":"","start":"","top":"","no-gutter":"","inline":_vm.inline}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }